import { Box } from "@chakra-ui/layout";
import { IconButton, Tooltip } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";

type Props = {
  onMinimize: () => void;
};
export const ModalMinimize = ({ onMinimize }: Props) => {
  return (
    <Box pos="absolute" top="2" right="12">
      <Tooltip label={t`Minimize`} placement="top">
        <IconButton
          aria-label={t`Minimize`}
          colorScheme="grey"
          icon={<Icon name="minimize-01" />}
          onClick={onMinimize}
          size="sm"
          variant="ghost"
        />
      </Tooltip>
    </Box>
  );
};
